<template>
  <div class="container-fluid">
    <page-header
      :page="page"
      :has-return="!userCanAddEdit"
      :left-side-class="'col-xl-8'"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    >
      <template v-slot:customActions>
        <action-button
          v-if="userCanAddEdit"
          variant="success m-1"
          i="fas fa-file-plus pr-1"
          :responsive="false"
          @click="addForm"
        >
          Añadir
        </action-button>
      </template>
    </page-header>
    <FormSearch />
    <CustomSeparator
      text="Resultado de Formularios"
      class="mt-4 custom-separator-line"
    />
    <CustomResultNotFound
      v-if="results.length == 0"
      class="mt-4"
      :text="noResultsText"
    />
    <div class="row pt-2">
      <div class="col-12">
        <ResultRow
          v-for="(item, index) in results"
          :key="`row-item-${index}`"
          :item="item"
        />
      </div>
    </div>

    <div v-show="pagination.totalItemCount > 10" class="row">
      <div class="col-12 pt-0 mt-3">
        <pagination :data="pagination" @pagination-go-page="pageChanged" />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from 'pagination';
import PageHeader from 'PageHeader';
import CustomSeparator from 'custom-separator';
import ActionButton from 'ActionButton';
import FormSearch from './components/FormSearch';
import ResultRow from './components/ResultRow';
import { modulesName } from '@/modules';
import {
  actionTypes,
  getterTypes,
} from '@/modules/operation-form-management/store/types';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers(
  modulesName.operationFormManagementModuleName
);
import CustomResultNotFound from 'custom-result-not-found';

const CREATE_EDIT_FORM_ROUTE_NAME = 'CreateEditForm';

export default {
  name: 'Main',
  components: {
    PageHeader,
    CustomSeparator,
    ActionButton,
    FormSearch,
    ResultRow,
    CustomResultNotFound,
    Pagination,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-calculator',
        title: 'Manejo de Formularios',
        routes: ['Inicio', 'Operaciones', 'Manejo de Formularios'],
      },
      noResultsText: 'No se ha encontrado resultado de formularios en sistema.',
    };
  },
  computed: {
    userCanAddEdit() {
      return this.$store.getters.HasPermission('form.management');
    },
    ...mapGetters({
      pagination: getterTypes.GET_PAGINATION,
      filter: getterTypes.GET_FILTER,
      results: getterTypes.GET_RESULTS,
    }),
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    ...mapActions([actionTypes.FETCH_RESULTS]),
    addForm() {
      this.$router.push({ name: CREATE_EDIT_FORM_ROUTE_NAME });
    },
    getForms(filters) {
      this[actionTypes.FETCH_RESULTS](filters);
    },
    pageChanged(currentPage) {
      this.pagination.currentPage = currentPage;

      const filters = {
        categoryCode: this.filter.category?.id ?? '',
        searchField: this.filter.searchField,
        isActive: this.filter.isActive,
        currentPage: currentPage,
      };
      this.getForms(filters);
    },
    perPageChange(params) {
      const filters = {
        categoryCode: this.filter.category?.id ?? '',
        searchField: this.filter.searchField,
        isActive: this.filter.isActive,
        count: params.currentPerPage,
      };
      this.getForms(filters);
    },
    clearFilters() {
      this.filter.category = null;
      this.filter.searchField = null;
      this.filter.isActive = true;
    },
  },
  beforeRouteEnter(_, from, next) {
    next((vm) => {
      if (from.name === 'CreateEditForm') {
        const filters = {
          categoryCode: vm.filter.category?.id ?? '',
          searchField: vm.filter.searchField,
          isActive: vm.filter.isActive,
          currentPage: vm.pagination.currentPage,
        };

        vm.getForms(filters);
      } else {
        vm.clearFilters();
        vm.getForms(vm.filter);
      }
    });
  },
};
</script>
<style scoped>
@media only screen and (max-width: 375px) {
  ::v-deep .separator-custom {
    font-size: 12px !important;
    line-height: 18px !important;
  }
}
</style>
